import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate, useParams, useLocation, Routes, Route } from "react-router-dom";
import "./CHAMPMainView.css";

import { LoadingSpinner } from "Projects/CC_cubi_clan_project/GlobalComponents/LoadingSpinner/LoadingSpinner";
import { NavMenu } from "Projects/CC_cubi_clan_project/GlobalComponents/NavMenu/NavMenu";
import { handleNavLinks } from "Projects/CC_cubi_clan_project/Utils/Utils";
import { getApp, getAppPermisions } from "Projects/CC_cubi_clan_project/Utils/PermissionManager";
import CHAMPHomeView from "Projects/CHAMP_championsjourney_project/Views/CHAMPHomeView/CHAMPHomeView";
import GameDetail from "Projects/CHAMP_championsjourney_project/Components/GameDetail/GameDetail";
import CHAMPAdminPanel from "Projects/CHAMP_championsjourney_project/Components/CHAMPAdminPanel/CHAMPAdminPanel";

function CHAMPGameRoute({ onLoading }) {
  const { codigo } = useParams();
  const navigate = useNavigate();
  return (
    <div className="champ-home">
      <GameDetail
        gameCodigo={codigo}
        onBack={() => navigate("/champ")}
        onLoading={onLoading}
      />
    </div>
  );
}

export default function CHAMPMainView() {
  const navigate = useNavigate();
  const location = useLocation();
  const [cookies] = useCookies();
  const [isLoggedInCallback, setIsLoggedInCallback] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  const isLoggedIn = !!cookies.SESSION_ID || isLoggedInCallback;

  // Derivar ítem activo del nav a partir de la URL actual
  const navActive = location.pathname.startsWith("/champ/admin") ? "Admin" : "Home";

  useEffect(() => {
    if (!isLoggedIn) return;
    (async () => {
      try {
        const app = await getApp("CHAMP", () => {});
        if (app) {
          const perms = await getAppPermisions(app, () => {});
          if (Array.isArray(perms) && perms.some((p) => p && (p.nombre === "APP_ADMIN" || p.nombre === "APP_MANAGER"))) {
            setIsAdmin(true);
          }
        }
      } catch (e) {
        // sin permisos de admin
      }
    })();
  }, [isLoggedIn]);

  const navMenu = [
    {
      devName: "AppList",
      label: "Aplicaciones",
      active: navActive === "AppList",
      visible: true,
      disabled: false,
      url: "/home",
    },
    {
      devName: "Admin",
      label: "⚙️ Administración",
      active: navActive === "Admin",
      visible: isAdmin,
      disabled: false,
      url: "/champ/admin",
    },
  ];

  const onHandleNavLinks = (event, url) => {
    handleNavLinks(event, url, navigate, () => {});
  };

  return (
    <div className="champ-main">
      <LoadingSpinner isLoading={isLoading} />
      <NavMenu
        title="Champion's Journey"
        appCode="CHAMP"
        navMenu={navMenu}
        onHandleNavLinks={onHandleNavLinks}
        onLoggedIn={setIsLoggedInCallback}
        onLoading={setIsLoading}
      />
      {isLoggedIn && (
        <Routes>
          <Route path="/" element={<CHAMPHomeView onLoading={setIsLoading} />} />
          <Route path="game/:codigo" element={<CHAMPGameRoute onLoading={setIsLoading} />} />
          <Route path="admin" element={<CHAMPAdminPanel onLoading={setIsLoading} />} />
        </Routes>
      )}
    </div>
  );
}
